import { ChecklistModel } from '@akin-home/checklists';
import { useListTaskListsByHabitat } from '@akin-home/checklists/frontend';
import { useHabitatID } from '@akin-home/habitats/react';
import React, { FC, useMemo, useState } from 'react';
import { FlatList, ModalProps, View } from 'react-native';
import styled from 'styled-components/native';
import ChecklistBulletTile from '../../checklists/components/ChecklistBulletTile/ChecklistBulletTile';
import NewButton from '../Button/NewButton';
import Dialog from '../Dialog';
import DialogHeader from '../Dialog/DialogHeader';
import Spacer from '../Spacer';
import Text from '../Text';
import TextInput from '../TextInput';

export interface Props extends Partial<ModalProps> {
  title?: string;
  onSelect: (list: ChecklistModel) => void;
  /**
   * An optional checkbox override for bullet points
   */
  bullet?: boolean | false;
}

const TaskListSelectModal: FC<Props> = (props) => {
  const { onSelect, bullet, ...modalProps } = props;

  const habitatID = useHabitatID();

  const { lists: items } = useListTaskListsByHabitat({ habitatID });

  const [state, setState] = useState({
    input: '',
  });

  const onChangeInput = (input: string) =>
    setState({
      ...state,
      input,
    });

  const filtered_items = useMemo(
    () =>
      state.input.length
        ? items?.filter((item) =>
            item.title.toLowerCase().includes(state.input.toLowerCase())
          )
        : items,
    [items, state.input]
  );

  return (
    <StyledDialogue {...modalProps}>
      <Container>
        <DialogHeader
          center={<Text weight="semibold">Select a list</Text>}
          right={
            <NewButton
              icon="times"
              variant="text"
              onPress={modalProps.onDismiss}
            />
          }
        />

        <Body>
          <StyledTextInput
            placeholder="Search List Name"
            value={state.input}
            onChangeText={onChangeInput}
          />

          <Spacer height="8px" />
        </Body>

        <FlatList
          data={filtered_items}
          contentContainerStyle={content_container_style}
          renderItem={({ item }) => (
            <View>
              <ChecklistBulletTile item={item} onPress={onSelect} />
              <Spacer height="16px" />
            </View>
          )}
        />
      </Container>
    </StyledDialogue>
  );
};

const content_container_style = { paddingHorizontal: 8 };

const Container = styled.View`
  height: 100%;
  max-width: 100%;
`;

const Body = styled.View`
  padding: 8px;
`;

const StyledDialogue = styled(Dialog)`
  max-width: 80%;
`;

const StyledTextInput = styled(TextInput)`
  min-width: 50px;
`;

export default TaskListSelectModal;
